import type { ConsentType } from '@repo/domain';
import { tr } from '@repo/locale';

import {
  APP_TERMS_URL,
  CONTROLLER_RULES_URL,
  CONTROLLER_STUDENT_AGREEMENT_URL,
  PARKING_TERMS_URL,
  PRIVACY_POLICY_URL,
} from '@shared/constants/constants';

interface Props {
  type: ConsentType;
}

function getDocumentUrl(type: ConsentType): string | undefined {
  switch (type) {
    case 'controlRules':
      return CONTROLLER_RULES_URL;
    case 'controllerStudentAgreement':
      return CONTROLLER_STUDENT_AGREEMENT_URL;
    case 'termsApp':
      return APP_TERMS_URL;
    case 'termsParking':
      return PARKING_TERMS_URL;
    case 'privacy':
    case 'rodo':
      return PRIVACY_POLICY_URL;
    case 'marketing':
    case 'recruitmentCurrent':
    case 'recruitmentFuture':
      return undefined;
    default: {
      const _exhaustive: never = type;
      return _exhaustive;
    }
  }
}

export default function ConsentLabel({ type }: Props) {
  const documentUrl = getDocumentUrl(type);
  const text = tr(`common:consents.${type}.text`);

  if (documentUrl === undefined) return <>{text}</>;

  return (
    <>
      {text}{' '}
      <a href={documentUrl} target="_blank" rel="noopener noreferrer" className="underline">
        {tr(`common:consents.${type}.link`)}
      </a>
    </>
  );
}
